import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./PopUpChatOrClassifier.css";

function PopUpChatOrClassifier({isOpen, onClose, onCreateChat, onCreateClassifier,}) {
  const { t: tHub } = useTranslation("hub");
  const [isChatHovered, setIsChatHovered] = useState(false);
  const [isClassifierHovered, setIsClassifierHovered] = useState(false);

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget && onClose) {
      onClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="PopUpChatOrClassifier-overlay" onClick={handleOverlayClick}>
      <article className="PopUpChatOrClassifier" data-testid="popup-chat-classifier">
        <div className="ChatOrClassifier-Wrapper">
          <button className="btn-create-chat" data-testid="btn-create-chat" onClick={onCreateChat}>
            <img
              src={
                isChatHovered
                  ? "/imagens/create-chat-white.svg"
                  : "/imagens/create-chat.svg"
              }
              className="img-create-chat"
              alt={tHub("my_component_create_chat_title")}
              onMouseEnter={() => setIsChatHovered(true)}
              onMouseLeave={() => setIsChatHovered(false)}
            />
            <h3 className="btn-create-title">
              {tHub("my_component_create_chat_title")}
            </h3>
            <p className="btn-create-paragraph">
              {tHub("my_component_create_chat_description")}
            </p>
          </button>

          <button className="btn-create-classifier" data-testid="btn-create-classifier" onClick={onCreateClassifier}>
            <img
              src={
                isClassifierHovered
                  ? "/imagens/create-classifier-white.svg"
                  : "/imagens/create-classifier.svg"
              }
              className="img-create-classifier"
              alt={tHub("my_component_create_classifier_title")}
              onMouseEnter={() => setIsClassifierHovered(true)}
              onMouseLeave={() => setIsClassifierHovered(false)}
            />
            <h3 className="btn-create-title">
              {tHub("my_component_create_classifier_title")}
            </h3>
            <p className="btn-create-paragraph">
              {tHub("my_component_create_classifier_description")}
            </p>
          </button>
        </div>
      </article>
    </div>
  );
}

export default PopUpChatOrClassifier;
